import React from 'react';
import villaOverviewImage from '../img/elevation_img_25.avif'; // Replace with your actual image
import  useScrollToTop from './useScrollToTop';
import groundFloorPlan from '../img/img_floorplan_3.avif'; // Replace with your actual image
import firstFloorPlan from '../img/img_floorplan_2.avif';  // Replace with your actual image
import interiorLivingRoom from '../img/living_room_img_1.avif'; // Replace with your actual image
import villaExterior from '../img/px_img.avif'; // Replace with your actual image
import './ProjectStyles.css';
// import locationMap from '../img/patna_location.png'; // Replace with an image of the location if needed

const ModernVillaDetails = () => {
  useScrollToTop();
  return (
    <div className='project-container'>
      <h2>Modern Villa: Spacious Living in a Contemporary Design</h2>
      <img className='project-image' src={villaOverviewImage} alt="Modern Villa Overview" />
      <div className='project-details'>
        <p>Introducing a stunning contemporary villa designed for spacious living and modern aesthetics. Situated on a 50x80 sqft plot with a generous 4000 sqft built area, this design emphasizes open layouts, natural light, and high-quality finishes.</p>

        <h3>Design Concept</h3>
        <p>The core design principles revolve around clean lines, minimalist detailing, large windows to maximize natural light, and a seamless connection between indoor and outdoor spaces. We aim to create a serene and sophisticated living environment.</p>

        <h3>Inspiration</h3>
        <div className='inspiration-gallery'>
          {/* Replace these with actual image paths */}
          <img src='../img/inspiration_1.jpg' alt='Inspiration 1' className='project-image' />
          <img src='../img/inspiration_2.jpg' alt='Inspiration 2' className='project-image' />
          <img src='../img/inspiration_3.jpg' alt='Inspiration 3' className='project-image' />
          {/* Add more inspiration images as needed */}
        </div>
      </div>

      <div className='project-details'>
        <h3>Detailed Floor Plans: Experience the Spaciousness</h3>
        <div className='floor-plan-section'>
          <h4>Ground Floor Plan</h4>
          <img className='project-image' src={groundFloorPlan} alt="Ground Floor Plan" />
          <p>The ground floor features an open-plan living and dining area, a modern kitchen, and potentially a guest bedroom or study. Large windows and seamless transitions to outdoor spaces are key elements.</p>
          {/* You could add more specific details about room dimensions and features here */}
        </div>

        <div className='floor-plan-section'>
          <h4>First Floor Plan</h4>
          <img className='project-image' src={firstFloorPlan} alt="First Floor Plan" />
          <p>The first floor typically includes the master suite with a private bathroom and balcony, as well as additional bedrooms and bathrooms designed for comfort and privacy.</p>
          {/* Add more specific details about room dimensions and features here */}
        </div>

        <div className='built-area-breakdown'>
          <h4>Built Area Breakdown</h4>
          <p>The total built area of 4000 sqft is thoughtfully distributed across the ground and first floors to maximize usable space and create a comfortable living environment.</p>
          {/* You could provide a more detailed breakdown if you have the specific numbers */}
        </div>
      </div>

      <div className='project-details'>
        <h3>Luxurious Interiors: Comfort and Style</h3>
        <div className='interior-feature'>
          <h4>Open Plan Living</h4>
          <img className='project-image' src={interiorLivingRoom} alt="Open Plan Living Area" />
          <p>The villa boasts an expansive open-plan living, dining, and kitchen area, fostering a sense of connection and flow. This design maximizes natural light and creates a perfect space for family gatherings and entertaining.</p>
        </div>

        <div className='interior-feature'>
          <h4>Natural Light</h4>
          <p>Large strategically placed windows and glass doors are integral to the design, bathing the interiors in natural light and offering seamless views of the surroundings.</p>
        </div>

        <div className='interior-feature'>
          <h4>Material Palette</h4>
          <p>We envision a sophisticated material palette featuring elements such as large format tiles or hardwood flooring, smooth plaster walls with potential accent features, and thoughtfully designed ceiling treatments to enhance the ambiance.</p>
        </div>

        {/* Add more interior features as needed */}
      </div>

      <div className='project-details'>
        <h3>Contemporary Exterior: Form and Function</h3>
        <img className='project-image' src={villaExterior} alt="Villa Exterior" />

        <div className='exterior-feature'>
          <h4>Architectural Style</h4>
          <p>The exterior design embraces clean lines, geometric forms, and a modern aesthetic. Features like flat or low-pitched roofs and a balanced use of materials such as concrete, glass, and metal contribute to its contemporary appeal.</p>
        </div>

        <div className='exterior-feature'>
          <h4>Facade Treatment</h4>
          <p>The facade will feature a combination of high-quality materials, creating visual interest and ensuring durability. Specific materials will be selected to complement the overall design and enhance the villa's curb appeal.</p>
        </div>

        {/* Add more exterior features as needed */}
      </div>

      <div className='project-details'>
        <h3>Quality Materials: Built to Last</h3>
        <div className='materials-list'>
          <h4>Material Specifications (Proposed)</h4>
          <ul>
            <li><strong>Structure:</strong> Reinforced Concrete</li>
            <li><strong>Exterior Walls:</strong> Smooth Plaster with Premium Exterior Paint, Potential Stone or Wood Cladding Accents</li>
            <li><strong>Roofing:</strong> Flat Roof with Waterproofing Membrane and Thermal Insulation</li>
            <li><strong>Windows and Doors:</strong> Aluminum or uPVC Frames with Double-Glazed Units</li>
            <li><strong>Flooring:</strong> Large Format Porcelain Tiles in Living Areas, Engineered Hardwood in Bedrooms</li>
            <li><strong>Wall Finishes (Interior):</strong> Smooth Plaster with Premium Interior Paint</li>
            <li><strong>Bathroom and Kitchen Fixtures:</strong> Modern, High-Quality Brands (Specifics to be determined)</li>
            {/* Add more material specifications as needed */}
          </ul>
        </div>

        {/* Add a section for Sustainability Features if applicable */}
      </div>

      {/* Optional: Location and Context */}
      {/* <div className='project-details'>
        <h3>Situated in [Specific Neighborhood/Area], Patna</h3>
        {locationMap && <img className='project-image' src={locationMap} alt="Location Map" />}
        <p>This modern villa is ideally located in a desirable neighborhood of Patna, offering a blend of tranquility and convenience.</p>

        <div className='location-details'>
          <h4>Accessibility</h4>
          <ul>
            <li>Proximity to [mention key landmarks, schools, hospitals]</li>
            <li>Easy access to major transportation routes</li>
          </ul>
        </div>
      </div> */}
    </div>
  );
};

export default ModernVillaDetails;